// extracted by mini-css-extract-plugin
export default {"form":"Form_form__9QS4M","form-input":"Form_form-input__fSJDd"};